const startButton = document.getElementById("start-btn");
const nextButton = document.getElementById("next-btn");
const showMeButton = document.getElementById("show-me-how-btn");
const questionContainerElement = document.getElementById("question11-container");
const questionElement = document.getElementById("question11");
const answerButtonsElement = document.getElementById("answer-buttons11");
const ctaElement = document.getElementById("cta11");


const questions11 = [
  {
    question:
      "What kind of information does your sales team use?",
    answers: [
      { text: "Call Duration", correct: true },
      { text: "Call Wait Times", correct: true },
      { text: "Caller ID", correct: true },
      { text: "Not Sure", correct: true },
    ],
  },
  {
    question: "How often does your team review sales calls?",
    answers: [
      { text: "Every hour", correct: true },
      { text: "Every day", correct: true },
      { text: "During the week", correct: true },
      { text: "I don’t know", correct: true },
    ],
  },
  {
    question: "What do you need help with?",
    answers: [
      { text: "Improving data records", correct: true },
      { text: "Improving sales opportunities", correct: true },
    ],
  },
];


let shuffledQuestions11, currentQuestionIndex11;

startButton.addEventListener("click", startQuiz);
nextButton.addEventListener("click", () => {
  currentQuestionIndex11++;
  setNextQuestion();
  rotateGallery();
});

function startQuiz() {
  startButton.classList.add("hide");
  shuffledQuestions11 = questions11.sort();
  // () => Math.random() - 0.5;
  currentQuestionIndex11 = 0;
  questionContainerElement.classList.remove("hide");
  setNextQuestion();
}

function setNextQuestion() {
  resetState();
  if(currentQuestionIndex11 > questions11.length - 1){
    displaySuccess();
    return
  } 
  showQuestion(shuffledQuestions11[currentQuestionIndex11]);
}

function displaySuccess(){
  ctaElement.innerText =
  "Good news! DYL’s Call Detail Records ensure your team has more information to convert prospects to customers. Click below to find out how.";
  questionContainerElement.classList.add("hide");
  ctaElement.classList.remove("hide");
  showMeButton.classList.remove("hide");
}

function showQuestion(question) {
  questionElement.innerText = question.question;
  question.answers.forEach((answer) => {
    const button = document.createElement("h5");
    button.innerText = answer.text;
    button.classList.add("btn-block");
    button.classList.add("btn-primary");
    button.classList.add("p-2");
    button.classList.add("transition-3d-hover");
    button.classList.add("text-center");
    if (answer.correct) {
      button.dataset.correct = answer.correct;
    }
    button.addEventListener("click", selectAnswer);
    answerButtonsElement.appendChild(button);
  });
}

function resetState() {
  clearStatusClass(document.body);
  nextButton.classList.add("hide");
  while (answerButtonsElement.firstChild) {
    answerButtonsElement.removeChild(answerButtonsElement.firstChild);
  }
}

function selectAnswer(e) {
  const selectedButton = e.target;
  const correct = selectedButton.dataset.correct;
  setStatusClass(document.body, correct);
  Array.from(answerButtonsElement.children).forEach((button) => {
    setStatusClass(button, button.dataset.correct);
    selectedButton.style.backgroundColor = "green";
  });
    nextButton.classList.remove("hide");
}


function setStatusClass(element, correct) {
  clearStatusClass(element);
  if (correct) {
    element.classList.add("correct");
  } else {
    element.classList.add("wrong");
  }
}

function clearStatusClass(element) {
  element.classList.remove("correct");
  element.classList.remove("wrong");
}

let counter = 0,
  gallery = [
    "https://images.dyl.com/marketing-web/images/quiz/fitness-group-working-out-with-dumbbells.jpg",
    "https://images.dyl.com/marketing-web/images/quiz/soccer-coach-high-fiving-boy-player-black-and-white.jpg",
    "https://images.dyl.com/marketing-web/images/quiz/woman-smiling-excited-with-yellow-background.jpg",
  ];
function rotateGallery() {
  document.getElementById("ImgGalleryCDR").src = gallery[counter];
  counter++;
  if (counter >= gallery.length) {
    counter = 0;
  }
}

